import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const pa = cfg.url?.startsWith("/platform/");
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.startsWith('/customer/') && !cfg.url?.startsWith("/auth/") && !cfg.url?.startsWith("/platform/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post(pa ? "/platform/auth/refresh" : "/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event(pa ? "pa-logout" : "mbp-logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const inr = (p) =>
  "₹" + ((p || 0) / 100).toLocaleString("en-IN", { minimumFractionDigits: (p || 0) % 100 ? 2 : 0, maximumFractionDigits: 2 });

export function calcTotals(subtotal, tp = {}, discount = 0) {
  const taxable = subtotal - Math.max(0, Math.min(discount, subtotal));
  const r = (v, bps) => Math.floor((v * (bps || 0) + 5000) / 10000);
  const service = r(taxable, tp.service_charge_bps);
  const base = taxable + service;
  const cgst = r(base, tp.cgst_bps);
  const sgst = r(base, tp.sgst_bps);
  return { subtotal, service, cgst, sgst, total: base + cgst + sgst };
}

export function uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "k" + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
}

export async function downloadBlob(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 4000);
}

export function toCSV(rows) {
  if (!rows?.length) return "";
  const keys = Object.keys(rows[0]);
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  return [keys.join(","), ...rows.map((r) => keys.map((k) => esc(r[k])).join(","))].join("\n");
}

export function saveCSV(name, rows) {
  const blob = new Blob([toCSV(rows)], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
}

export function minutesSince(iso) {
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
}

export { beep } from "./sound";
